module.exports = __webpack_public_path__ + "img/login_logo.7e00902e.png";